const HighRpsOffer = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="72" height="76" viewBox="0 0 72 76" fill="none">
            <g opacity="0.1">
                <path
                    d="M45.4627 -9.79983C46.9173 -11.0619 49.0788 -11.0619 50.5334 -9.79983L55.2725 -5.68818C56.1701 -4.90945 57.3758 -4.58639 58.5425 -4.81201L64.7025 -6.00324C66.5933 -6.36888 68.4652 -5.28817 69.0939 -3.46786L71.1423 2.46249C71.5302 3.58569 72.4128 4.46829 73.536 4.85625L79.4664 6.90463C81.2867 7.53337 82.3674 9.40523 82.0018 11.296L80.8105 17.4561C80.5849 18.6227 80.908 19.8284 81.6867 20.726L85.7984 25.4651C87.0604 26.9198 87.0604 29.0812 85.7984 30.5359L81.6867 35.275C80.908 36.1726 80.5849 37.3782 80.8105 38.5449L82.0018 44.7049C82.3674 46.5957 81.2867 48.4676 79.4664 49.0963L73.536 51.1447C72.4128 51.5327 71.5302 52.4153 71.1423 53.5385L69.0939 59.4688C68.4652 61.2891 66.5933 62.3699 64.7025 62.0042L58.5425 60.813C57.3758 60.5874 56.1701 60.9104 55.2725 61.6892L50.5334 65.8008C49.0788 67.0629 46.9173 67.0629 45.4627 65.8008L40.7235 61.6892C39.826 60.9104 38.6203 60.5874 37.4536 60.813L31.2936 62.0042C29.4028 62.3699 27.5309 61.2891 26.9022 59.4688L24.8538 53.5385C24.4659 52.4153 23.5832 51.5327 22.4601 51.1447L16.5297 49.0963C14.7094 48.4676 13.6287 46.5958 13.9943 44.7049L15.1855 38.5449C15.4112 37.3782 15.0881 36.1726 14.3094 35.275L10.1977 30.5359C8.93567 29.0812 8.93567 26.9198 10.1977 25.4651L14.3094 20.726C15.0881 19.8284 15.4112 18.6227 15.1855 17.4561L13.9943 11.296C13.6287 9.40523 14.7094 7.53337 16.5297 6.90463L22.4601 4.85625C23.5832 4.46829 24.4659 3.58569 24.8538 2.46249L26.9022 -3.46785C27.5309 -5.28817 29.4028 -6.36888 31.2936 -6.00324L37.4536 -4.81201C38.6203 -4.58639 39.826 -4.90945 40.7235 -5.68818L45.4627 -9.79983Z"
                    stroke="#0F6BFF"
                    stroke-width="4.72131"
                />
                <path
                    d="M64.001 12L32.001 44"
                    stroke="#0F6BFF"
                    stroke-width="4.72131"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M36.1914 16.6484H36.3041"
                    stroke="#0F6BFF"
                    stroke-width="11.6066"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M60.1904 40.6484H60.3031"
                    stroke="#0F6BFF"
                    stroke-width="11.6066"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
        </svg>
    )
}

export default HighRpsOffer
